module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"column":{"name":"管理施設名","sensor_count":"センサー数","timeline":"タイムライン","detection_trend":"検出数推移","floor_plans":"図面"},"button":{"show":"表示する"},"no_data":"管理施設がありません"},"en":{"column":{"name":"Facility name","sensor_count":"Sensors","timeline":"Timeline","detection_trend":"Detection Trend","floor_plans":"Floor Plans"},"button":{"show":"Show"},"no_data":"No facilities available"}}')
  delete Component.options._Ctor
}
